import ctx from "@/ctx";
import fetch from "../../utils/fetch";

let Items = function(d) {
  let self = this;
  self.items = d;

  self.get = function(id) {
    return self.items.find(i => {
      return i.id === id;
    });
  };
};

export default async () => {
  console.log("ctx.src.diagnosis: loaded");
  const res = await fetch.get("/api/medcases/diagnosis/get-all");
  if (res) ctx.src.diagnosis = new Items(res);
  console.log("ctx.src.diagnosis: initialized");
};
